import axios from "../httpClient";

export const getSecretById = async (secretId) => {
    const result = await axios.post(`/olympus/secret/access`, {
        secretId
    });
    return result.data.plainTextSecret;
};

export const updateSecretById = async (secretId, newValue) => {
    const result = await axios.patch(`/olympus/secret/update`, {
        secretId,
        newValue,
    });
    return;
};
